import {
  Observable,
  BehaviorSubject,
  Subject,
  map,
  startWith,
  combineLatest,
  distinctUntilChanged,
  debounceTime,
  tap,
  filter,
  takeUntil,
} from "rxjs";
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  TemplateRef,
  ContentChild,
} from "@angular/core";
import {
  SharedModule,
  DataService,
  ConfigurableOperationInput,
} from "@bb-vendure/admin-ui/core";
import { UntypedFormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FetchInboundingDocument,
  FetchInboundingQuery,
} from "../../../generated-graphql/graphql";

@Component({
  selector: "inbound-extend-view",
  standalone: true,
  templateUrl: "./view.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./view.component.scss"],
  imports: [SharedModule],
})
export default class InboundExtendView implements OnInit, OnDestroy {
  @Input() inboundId: string;

  inbound$: Observable<FetchInboundingQuery["inbounding"]>;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected dataService: DataService
  ) {}

  ngOnInit() {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (params.get("contents") === null) return;
      this.inbound$ = this.dataService
        .query(FetchInboundingDocument, { id: params.get("contents")! })
        .single$.pipe(
          map((result) => {
            return result.inbounding;
          })
        );
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
